:host {
  --grid-column-gap: calc(2 * var(--spacer));
  --grid-row-gap: calc(2 * var(--spacer));
  --max-width: 1366px;
  width: 100%;
  height: 100%;
  display: block;
  background-color: var(--white-layout-301-level-0-elevation);
}

.grid-container {
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  grid-auto-flow: column;
  max-width: var(--max-width);
  gap: var(--grid-row-gap) var(--grid-column-gap);
  margin: 15px auto;
  background-color: var(--white-layout-301-level-0-elevation);
}

.grid-cell {
  background-color: var(--white-layout-301-level-0-elevation);
  max-width: var(--max-width);
}

.dynamic-widget {
  height: 100%;
  width: 100%;
  flex-direction: row !important;
}

.homepage-dynamic-card-wrapper {
  background-color: var(--blue-layout-403-primary);
  border-radius: 5px;
  padding: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: space-between;

  .card-title {
    color: white;
  }

  .card-description {
    overflow: hidden;
    max-height: 70px;
    color: white;
  }

  .card-button {
    background-color: white;
    text-decoration: none;
    color: var(--blue-layout-400-primary);
    width: fit-content;
    cursor: pointer;
    font-size: var(--button-font-size);
    line-height: 2;
    border-radius: var(--button-border-radius);
    text-align: center;
    padding: 0 calc(2* var(--spacer));
    transition: all 0.3s ease;
    height: var(--button-height);
    min-width: calc(2.25* var(--button-height));
    max-width: var(--button-max-width, unset);
    font-weight: 500;
    border: 1px solid;
    border-color: inherit;
    text-transform: var(--button-text-transform, uppercase);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .card-button:hover {
    background-color: var(--blue-layout-104-solid-background);
  }
}
